<template>
	<div class="editor-content"
		ref="editorContent"
		:style="{
			width: `${width}px`,
			height: `${width/16*9}px`,
			top: `${top}px`,
			left: `${left}px`
		}"
	>
		<EditorPlay :style="{
			transform: `scale(${width / 1920})`
		}" />
	</div>
</template>
<script>
import EditorPlay from './editorPlay'
import { mapGetters } from 'vuex';

export default {
	name: 'EditorContent',
	components: {
		EditorPlay
	},
	computed: {
		...mapGetters({
			width: 'previewInit/width',
			top: 'previewInit/top',
			left: 'previewInit/left'
		})
	},
	watch: {
		width() {
			this.$nextTick(() => {
				window.postMessage({name: "sizeChange", data: this.$refs.editorContent.getBoundingClientRect()}, "*")
			})
		}
	},
	mounted() {
		this.$nextTick(() => {
			window.postMessage({name: "sizeChange", data: this.$refs.editorContent.getBoundingClientRect()}, "*")
		})
	}
}
</script>
<style lang="scss" scoped>
.editor-content {
	position: relative;
	top: 0;
	left: 0;
	width: 1072px;
  height: 603px;
	background-color: transparent;
	// background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/draftPreview/EditorContent.vue